export default "__VITE_ASSET__yWipRh0m__"